module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh-bot",
    attrs: {
      "id": "ch3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Three")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("Maureene Pinter lived in a frame cottage separated from the main house and her twin sister by a quarter acre of overgrown woods.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Inside, sunlight slanted through windows clouded by dirt and rain spots. Dust floated on the air, settling on the Scottish terrier that lay, belly-up, on the sofa. The dog snorted and twitched a paw in its sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maureene sat hunched on a stool in front of her easel, rolling a stick of charcoal between two fingers. Her short salt-and-pepper hair stuck out on one side of her head. The canvas in front of her sported two curved lines. They could have represented anything or nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Someone knocked on the door. The terrier barked sleepily, then twisted to its feet and jumped to the floor. Its claws clicked on the scarred linoleum as it followed Maureene to the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She pulled aside a curtain covering the door’s window, then swiveled the dead bolt and opened it before going back to her stool.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maxwell Thorne stepped inside. A broker for Rothwell’s auction house, he wore at least three thousand dollars’ worth of clothes. The charcoal suit wasn’t showy, but the material hung perfectly. His shoes were slightly interesting, his watch deceptively simple, and his tie a work of art.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He reached down and spoke to the dog while scratching its head. “Hilda, it’s good to see you again. You, too, Maureene.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maureene didn’t turn from her canvas. “What do you want, Max?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Max strolled along the perimeter of the room, tilting his head to look at the titles in a dusty bookcase. “I’d like to take you out to lunch. What do you say?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’d say I haven’t showered and my hair looks like roadkill.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A trio of carved elephants sat on one shelf. Maxwell touched the tusk of the smallest. “Put a hat on. Hats are expected of artists.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maureene rubbed a finger across one of the charcoal marks, softening it. “Who else would be coming to lunch?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No one, if that’s what you want.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What do "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("you")]), _vm._v(" want?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What do "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("I")]), _vm._v(" want?” Max straightened. “I want your portrait of Doreene to sell for so much that the rest of your existing paintings bring in seven figures apiece. I want your renewed fame to cause gallery owners to camp on your doorstep, begging you to paint more. I want museum curators to rend their clothes when they can’t afford a Pinter for their "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Great Portraitists of the Twenty-first Century")]), _vm._v(" installations.” He smiled. “In short, I want you to come out to a nice lunch with two very gentle members of the press and talk about yourself and Doreene’s portrait.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maureene shook her head slowly. “She can’t sell that painting.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Max put his hands in his pockets and came over. He glanced at the canvas, then at the back of Maureene’s neck, where charcoal streaked her weathered skin. “Are we talking about legalities? Because Doreene has a letter from you, giving her the painting.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maureene looked up at him, her face bleak. “That portrait is a part of me. If she sells it, I don’t know what will happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Max frowned. “This is not something people in my profession usually say, but "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("it’s just a painting.")]), _vm._v("” He smiled suddenly. “Are you playing the eccentric-artiste card? It’s true that a little tasteful insanity can add to a painter’s caché, but you shouldn’t waste it on me. I’ll have Elizabeth arrange a TV interview if you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maureene looked at the canvas again. “Go away, Max.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll come back in an hour, all right? Is that long enough for you to shower and dress? Then we’ll have a nice lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maureene stood and faced him. “I mean it. If you won’t help me change Doreene’s mind, then get out.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hilda, who had been busily nosing at the corner of an area rug, looked up and growled, her teeth bared.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maxwell backed toward the door. “Maureene, tell me what’s wrong. Do you need a change of scene? Maybe there’s something I can do to help.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“There is. Don’t sell the painting.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“If I don’t, Doreene will just find someone else. It’s going to happen, Maureene.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Hilda gave a sharp bark.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It can’t,” Maureene said. “It just can’t.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecd96f70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 78
// module chunks = 0